import {FC} from 'react'
import {downloadTemplateEquipment, uploadMasiveEquipment} from '../../../../services'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
const MasiveUploadEquipment: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasiveEquipment(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateEquipment}
      handleSendService={handleUpload}
      textData1='Carga masiva de Equipos:'
      textData='Carga masiva de Equipo:'
      title='Equipos'
    />
  )
}

export {MasiveUploadEquipment}
